



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import 'summernote/dist/summernote-lite.js';
import 'summernote/dist/lang/summernote-ja-JP.min.js';
import 'summernote/dist/lang/summernote-zh-CN.min.js';
import 'summernote/dist/lang/summernote-ko-KR.min.js';
import {uploadFile, isHTML} from '@/utils/commonUtils';
import Cookies from 'js-cookie';
import {I18N_LOCALE} from '@/const/words/cookie';
import { pattern } from '@/const/regex';

const msWordOpTagRegex = new RegExp(pattern['ms-op-tag'], 'g');

@Component
export default class Editor extends Vue {
  @Prop({required: false})
  private readonly options?: any;
  @Prop({required: false, default: false})
  private readonly disable?: boolean;
  @Prop({required: false, default: ''})
  private readonly data?: string;
  @Prop({required: false})
  private readonly mallNo!: string;
  @Prop({required: false, default: 'SummernoteLite' + Math.floor(Math.random() * 100) + 1})
  private readonly editorId?: string;
  @Prop({required: false, default: 'COMMON_FILE_SIZE_ERR_IMG'})
  private readonly checkSizeMsg?: string;
  @Prop({required: false, default: 'COMMON_FILE_YTPE_ERR_IMAGE'})
  private readonly checkTypeMsg?: string;

  @Watch('data', {immediate: false, deep: true})
  onDataChanged(newVal: any) {
    this.setData(newVal);
  }

  @Watch('disable')
  onDisableChanged(newVal: any) {
    const $summernote = jQuery(this.$refs.summernote);
    if (newVal) {
      $summernote.summernote('disable');
    } else {
      $summernote.summernote('enable');
    }
  }

  private setData(data: any) {
    const $summernote = jQuery(this.$refs.summernote);
    $summernote.summernote('reset');
    $summernote.on('summernote.change.codeview', (_: unknown, value: string) => {
      this.onEvent('onChange', value)
    });
    if (data) {
      if (isHTML(data)) {
        $summernote.summernote('code', data);
      } else {
        $summernote.summernote('insertText', data);
      }
    }
  }

  private uploadFile(files: any): void {
    let size;
    const someFileOfSize = Object.values(files).find((file: any): boolean => {
      size = file.size / 1024;
      return Math.ceil(size) > this.defaultOptions.imageFileSize;
    });
    if (someFileOfSize) {
      let msg = '';
      if (this.checkSizeMsg === 'COMMON_FILE_SIZE_ERR_IMG') {
        msg = window.$t(this.checkSizeMsg, [this.defaultOptions.imageFileSize / 1024 + 'M']);
      } else {
        msg = window.$t(this.checkSizeMsg, [this.defaultOptions.imageFileSize, size]);
      }
      alert(msg);
      return;
    }

    const someFileOfname = Object.values(files).find((file: any): boolean => {
      return !file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/);
    });
    if (someFileOfname) {
      alert(window.$t(this.checkTypeMsg));
      return;
    }

    uploadFile(files, this.mallNo).then((responses: any) => {
      const data = responses.map((res: any): {} => {
        return {url: res.data.url};
      });
      const $summernote = jQuery(this.$refs.summernote);
      data.forEach((imgInfo: any): void => {
        const $img = jQuery('<img>').attr('src', imgInfo.url);
        $summernote.summernote('insertNode', $img[0]);
      });
    });
  }

  public callbackOption: any = {
    callbacks: {
      onImageUpload: this.uploadFile,
      onChange: (contents: any) => this.onEvent('onChange', contents),
      onFocus: () => { this.$parent.$emit('focus') }
    }
  };

  public onEvent(event: string, value: string = '') {
    const validatedValue = this.getMsWordValidatedValue(value);

    if (event === 'onChange') {
      const removeHtmlTag = validatedValue.replace(/<[^>]*>?/g, '');
      const inputObj = { 
        html: validatedValue === '<p><br></p>' ? '' : validatedValue,
        text: removeHtmlTag
      };

      if (this.editorId) {
        Object.assign(inputObj, {editorId: this.editorId});
      }
      this.$parent.$emit('input', inputObj);
      return;
    }

    this.$emit(event, validatedValue);
  }

  public getHtml(): string {
    const $summernote = $(this.$refs.summernote);
    const html = $summernote.summernote('code');
    const value = this.getMsWordValidatedValue(html);

    return value === '<p><br></p>' ? '' : value;
  }

  public defaultOptions: any = {};
  public setOptions() {
    Object.assign(this.defaultOptions, {
      lang: this.langMap[Cookies.get(I18N_LOCALE)],
      width: 768,
      height: 300,
      placeholder: '',
      noHideDimmed: false,
      fontSize: 12,
      imageFileSize: 10240,
      useVideo: false,
      disableDragAndDrop: false,
      insertList: ['link', 'picture'],
      disableImageUpload: false,
      toolbar: [
        ['fontsize', ['fontsize']],
        ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
        ['color', ['color']],
        ['para', ['paragraph']],
        ['height', ['height']],
        ['picture', ['link', 'picture']],
        ['misc', ['codeview']]
      ],
      codeviewFilter: false,
      minHeight: 120
    });
  }

  private getMsWordValidatedValue(value: string) {
    //NOTE - ms word에서 복붙시 o:p태그가 함께 오는 것을 막음
    const deleteOpTagsValue = value.replace(msWordOpTagRegex, '');
    //NOTE - ms word에서 복붙시 border inline style 속성이 0으로 오는 현상이 있어 1로 강제 변환함
    return deleteOpTagsValue.replaceAll('border="0"', 'border="1"');
  }

  private langMap = {
    'en': 'en-US',
    'kr': 'ko-KR',
    'ja': 'ja-JP',
    'zh': 'zh-CN'
  }

  public init() {
    this.setOptions();
    if (this.options) {
      Object.assign(this.defaultOptions, this.options);
    }
    Object.assign(this.defaultOptions, this.callbackOption);
    this.run(this.defaultOptions);
  }

  public mounted() {
    this.init();
    this.$nextTick(() => {
      this.setData(this.data);
    });
  }

  public beforeDestroy() {
    this.run('destroy');
  }

  private focus() {
    const $summernote = $(this.$refs.summernote);
    $summernote.summernote('focus');
  }

  public run(options: any) {
    const $summernote = jQuery(this.$refs.summernote);
    $summernote.summernote(options);
    if (this.disable) {
      $summernote.summernote('disable');
    }
  }
}
